<!-- ヘッダー部分 -->
<div class="title-area">
  <h2 class="title">MYイベント</h2>
  @if (hasApprovalRequest) {
    <a class="approval-request" (click)="onTabChange('approval')">承認を依頼されているイベントがあります。</a>
  }
</div>

<!-- タブとフィルター -->
<div class="tab-filter-area-container">
  <div class="tab-filter-area">
    <div class="tabs">
      <button mat-flat-button
        class="tab-btn"
        [class.active]="activeTab === 'draft'"
        (click)="onTabChange('draft')">
        起票
      </button>
      <button mat-flat-button
        class="tab-btn"
        [class.active]="activeTab === 'approval'"
        (click)="onTabChange('approval')">
        承認
      </button>
    </div>
    <div class="filter-area">
      <mat-checkbox [(ngModel)]="showCompleted" (change)="onShowCompletedChange()" color="primary">
        {{ getCheckboxLabel() }}
      </mat-checkbox>
    </div>
  </div>
  @if (activeTab === 'draft') {
    <div class="btn-area">
      <button mat-raised-button color="warn" [disabled]="showSpinner" (click)="onCreate()">
        新規作成
      </button>
    </div>
  }
</div>

<!-- スピナー -->
@if (showSpinner) {
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <!-- 起票タブ -->
  @if (activeTab === 'draft') {
    <table class="event-table">
      <thead>
        <tr>
          <th class="col-document-type">帳票</th>
          <th class="col-status">ステータス</th>
          <th class="col-approval">承認進捗</th>
          <th class="col-event">イベント</th>
          <th class="col-unit">開催単位</th>
          <th class="col-participants">参加人数</th>
          <th class="col-scope">公開範囲</th>
          <th class="col-dates">開催日など</th>
        </tr>
      </thead>
      <tbody>
        @for (event of draftEvents; track event.id) {
          <tr>
            <!-- 帳票 -->
            <td class="col-document-type">
              {{ getDocumentTypeLabel(event.documentType) }}
            </td>

            <!-- ステータス -->
            <td class="col-status">
              <div class="status-content">
                {{ getStatusLabel(event.status) }}
                @if (event.status == 'returned') {
                  <div class="returned-icon"><span>差戻し</span></div>
                }
              </div>
            </td>

            <!-- 承認進捗 -->
            <td class="col-approval">
              <div class="approval-progress">
                <!-- 起票日 -->
                @if (getFormattedDate(event.approvalProgress.submittedDate)) {
                  <div class="approval-row start">
                    <span class="approval-label">起票</span>
                    <span class="approval-status"></span>
                    <span class="approval-date" [class.grayed]="event.approvalProgress.isSubmittedGrayed"><span class="date-full">{{ getFormattedDate(event.approvalProgress.submittedDate) }}</span><span class="date-short">{{ getShortDate(event.approvalProgress.submittedDate) }}</span></span>
                  </div>
                }
                <!-- 承認ステップ -->
                @for (step of event.approvalProgress.steps; track $index) {
                  @if (step.level !== null && step.status !== null) {
                    <div class="approval-row">
                      <span class="approval-label">{{ step.level }}次承認</span>
                      <span class="approval-status" [class]="'status-' + step.status">
                        {{ getApprovalStatusLabel(step.status) }}
                      </span>
                      <span class="approval-date" [class.grayed]="step.status === 'reviewing'">
                        @if (step.status !== 'reviewing') {<span class="date-full">{{ getFormattedDate(step.date) }}</span><span class="date-short">{{ getShortDate(step.date) }}</span>}
                      </span>
                    </div>
                  }
                }
              </div>
            </td>

            <!-- イベント -->
            <td class="col-event">
              <div class="event-content">
                <a class="event-title" (click)="onEventClick(event)">{{ event.title }}</a>
                <div class="event-category">{{ event.category }}</div>
                <!-- 概要：1440px以上は116文字、1024〜1439pxは50文字まで -->
                <div class="event-description desc-long">{{ getTruncatedDescription(event.description) }}</div>
                <div class="event-description desc-short">{{ getTruncatedDescription(event.description, 50) }}</div>
              </div>
            </td>

            <!-- 開催単位 -->
            <td class="col-unit">
              <!-- PC（1439px以下）では「支部/エリア」を「/」で区切って2行で表示する（unit-sep を隠す） -->
              @for (part of splitHoldingUnit(event.holdingUnit); track $index; let last = $last) {
                <span class="unit-part">{{ part }}</span>@if (!last) {<span class="unit-sep">/</span>}
              }
            </td>

            <!-- 参加人数 -->
            <td class="col-participants">
              <div class="participants-content">
                @if (event.participantCount !== null) {
                  <div class="number-with-unit">
                    <span class="participant-count">{{ event.participantCount }}</span>
                    <span class="unit">人</span>
                  </div>
                  @if (event.coverageRate !== null) {
                    <div class="coverage-rate">
                      <span class="coverage-label">カバー率</span>
                      <span class="coverage-value">{{ event.coverageRate }} %</span>
                    </div>
                  }
                } @else {
                  <span>-</span>
                }
              </div>
            </td>

            <!-- 公開範囲 -->
            <td class="col-scope">
              <div class="scope-content">
                <div class="scope-org">
                  {{
                    event.category === '労使交渉・協議・意見交換' || event.category === '組合年間行事'
                      ? '自組織'
                      : '他組織'
                  }}
                </div>
                @if (event.publicScope.permissionRole) {
                  <div class="scope-role">{{ event.publicScope.permissionRole }}</div>
                }
              </div>
            </td>

            <!-- 開催日など -->
            <td class="col-dates">
              <div class="dates-content">

                @for (date of getDisplayDates(event); track $index) {
                  <div class="event-date">{{ date }}</div>
                }

                @if (hasMoreDates(event)) {
                  <div class="more-dates">など</div>
                }

                <div class="last-updated">
                  <span class="last-updated-label">最終更新日</span>
                  <span class="last-updated-date">
                    {{ getFormattedDate(event.lastUpdatedAt) }}
                  </span>
                </div>

              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
    <div class="event-cards">
      @for (event of draftEvents; track event.id) {
        <ng-container *ngTemplateOutlet="eventCard; context: { $implicit: event, approval: false }"></ng-container>
      }
    </div>

    <!-- ページング -->
    @if (draftEvents.length > 0) {
      <div class="custom-pagination">
        <div class="pagination-container">

          @if (isFirstPage()) {
            <div class="paging-step paging-step-disable">
              <img src="assets/common/ChevronLeft_gray.svg" alt="前へ">
            </div>
          } @else {
            <button class="paging-step" (click)="previous()">
              <img src="assets/common/ChevronLeft.svg" alt="前へ">
            </button>
          }

          @for (pageNo of pages; track pageNo) {
            @if (pageNo !== page) {
              <div class="paging-link-container" (click)="goPage(pageNo)">
                <span class="paging-text">{{ pageNo }}</span>
              </div>
            } @else {
              <div class="current-page">
                <span class="paging-text">{{ pageNo }}</span>
              </div>
            }
          }

          @if (isLastPage()) {
            <div class="paging-step paging-step-disable">
              <img src="assets/common/ChevronRight_gray.svg" alt="次へ">
            </div>
          } @else {
            <button class="paging-step" (click)="next()">
              <img src="assets/common/ChevronRight.svg" alt="次へ">
            </button>
          }

        </div>
      </div>
    }

    <!-- イベントがない場合 -->
    @if (draftEvents.length === 0) {
      <div class="no-events">
        イベントがありません。
      </div>
    }
  }

  <!-- 承認タブ -->
  @if (activeTab === 'approval') {
    <table class="event-table approval-table">
      <thead>
        <tr>
          <th class="col-document-type">帳票</th>
          <th class="col-status">ステータス</th>
          <th class="col-approval">承認進捗</th>
          <th class="col-drafter">起票者</th>
          <th class="col-event">イベント</th>
          <th class="col-participants">参加人数</th>
          <th class="col-scope">公開範囲</th>
          <th class="col-dates">開催日など</th>
        </tr>
      </thead>
      <tbody>
        @for (event of approvalEvents; track event.id) {
          <tr>
            <!-- 帳票 -->
            <td class="col-document-type">
              <div class="document-type-content">
                <span>{{ getDocumentTypeLabel(event.documentType) }}</span>
              </div>
            </td>

            <!-- ステータス -->
            <td class="col-status">
              <div class="status-content">
                {{ getStatusLabel(event.status) }}
                @if (event.actionIcon === 'approval_request') {
                  <div class="returned-icon approval"><span>承認依頼</span></div>
                }
              </div>
            </td>

            <!-- 承認進捗 -->
            <td class="col-approval">
              <div class="approval-progress">
                <!-- 起票日 -->
                @if (event.approvalProgress.submittedDate) {
                  <div class="approval-row start">
                    <span class="approval-label">起票</span>
                    <span class="approval-status"></span>
                    <span class="approval-date" [class.grayed]="event.approvalProgress.isSubmittedGrayed"><span class="date-full">{{ getFormattedDate(event.approvalProgress.submittedDate) }}</span><span class="date-short">{{ getShortDate(event.approvalProgress.submittedDate) }}</span></span>
                  </div>
                }
                <!-- 承認ステップ -->
                @for (step of event.approvalProgress.steps; track $index) {
                  @if (step.level !== null && step.status !== null) {
                    <div class="approval-row">
                      <span class="approval-label">{{ step.level }}次承認</span>
                      <span class="approval-status" [class]="'status-' + step.status">
                        {{ getApprovalStatusLabel(step.status) }}
                      </span>
                      <span class="approval-date" [class.grayed]="step.status === 'reviewing'">
                        @if (step.status !== 'reviewing') {<span class="date-full">{{ getFormattedDate(step.date) }}</span><span class="date-short">{{ getShortDate(step.date) }}</span>}
                      </span>
                    </div>
                  }
                }
              </div>
            </td>

            <!-- 起票者 -->
            <td class="col-drafter">
              <!-- 役職・名前の下に間隔をあけて担当（支部・部署）を並べる -->
              <div class="drafter-content">
                @if (event.drafter.position) {
                  <div class="drafter-line drafter-position">{{ event.drafter.position }}</div>
                }
                @if (event.drafter.name) {
                  <div class="drafter-line drafter-name">{{ event.drafter.name }}</div>
                }
                @if (event.drafter.branch) {
                  <div class="drafter-line drafter-org">{{ event.drafter.branch }}</div>
                }
                @if (getDepartmentFromOrganizations(event)) {
                  <div class="drafter-line drafter-org">
                    @if (event.status !== 'completed') {
                      {{ getDepartmentFromOrganizations(event).master_type === 4
                        ? getMasterTypeName(getDepartmentFromOrganizations(event).master_type) + ' ' + getDepartmentFromOrganizations(event).path
                        : getDepartmentFromOrganizations(event).level === 0
                          ? getDepartmentFromOrganizations(event).path
                          : getMasterTypeName(getDepartmentFromOrganizations(event).master_type) + ' ' + getDepartmentFromOrganizations(event).path
                      }}
                    } @else{
                      @if (event.drafter.organizations_text?.length) {
                        {{ event.drafter.organizations_text[0] }}
                      }
                    }
                  </div>
                }
              </div>
            </td>

            <!-- イベント -->
            <td class="col-event">
              <div class="event-content">
                <a class="event-title" (click)="onApprovalEventClick(event)">{{ event.title }}</a>
                <div class="event-category">{{ event.category }}</div>
                <!-- 概要：1440px以上は116文字、1024〜1439pxは50文字まで -->
                <div class="event-description desc-long">{{ getTruncatedDescription(event.description) }}</div>
                <div class="event-description desc-short">{{ getTruncatedDescription(event.description, 50) }}</div>
              </div>
            </td>

            <!-- 参加人数 -->
            <td class="col-participants">
              <div class="participants-content">
                @if (event.participantCount !== null) {
                  <div class="number-with-unit">
                    <span class="participant-count">{{ event.participantCount }}</span>
                    <span class="unit">人</span>
                  </div>
                  @if (event.coverageRate !== null) {
                    <div class="coverage-rate">
                      <span class="coverage-label">カバー率</span>
                      <span class="coverage-value">{{ event.coverageRate }} %</span>
                    </div>
                  }
                } @else {
                  <span>-</span>
                }
              </div>
            </td>

            <!-- 公開範囲 -->
            <td class="col-scope">
              <div class="scope-content">
                <div class="scope-org">
                  {{
                    event.category === '労使交渉・協議・意見交換' || event.category === '組合年間行事'
                      ? '自組織'
                      : '他組織'
                  }}
                </div>
                @if (event.publicScope.permissionRole) {
                  <div class="scope-role">{{ event.publicScope.permissionRole }}</div>
                }
              </div>
            </td>

            <!-- 開催日など -->
            <td class="col-dates">
              <div class="dates-content">

                @for (date of getDisplayDates(event); track $index) {
                  <div class="event-date">{{ date }}</div>
                }

                @if (hasMoreDates(event)) {
                  <div class="more-dates">など</div>
                }

                <div class="last-updated">
                  <span class="last-updated-label">最終更新日</span>
                  <span class="last-updated-date">
                    {{ getFormattedDate(event.lastUpdatedAt) }}
                  </span>
                </div>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
    <div class="event-cards">
      @for (event of approvalEvents; track event.id) {
        <ng-container *ngTemplateOutlet="eventCard; context: { $implicit: event, approval: true }"></ng-container>
      }
    </div>

    <!-- ページング -->
    @if (approvalEvents.length > 0) {
      <div class="custom-pagination">
        <div class="pagination-container">

          @if (isFirstPage()) {
            <div class="paging-step paging-step-disable">
              <img src="assets/common/ChevronLeft_gray.svg" alt="前へ">
            </div>
          } @else {
            <button class="paging-step" (click)="previous()">
              <img src="assets/common/ChevronLeft.svg" alt="前へ">
            </button>
          }

          @for (pageNo of pages; track pageNo) {
            @if (pageNo !== page) {
              <div class="paging-link-container" (click)="goPage(pageNo)">
                <span class="paging-text">{{ pageNo }}</span>
              </div>
            } @else {
              <div class="current-page">
                <span class="paging-text">{{ pageNo }}</span>
              </div>
            }
          }

          @if (isLastPage()) {
            <div class="paging-step paging-step-disable">
              <img src="assets/common/ChevronRight_gray.svg" alt="次へ">
            </div>
          } @else {
            <button class="paging-step" (click)="next()">
              <img src="assets/common/ChevronRight.svg" alt="次へ">
            </button>
          }

        </div>
      </div>
    }

    <!-- イベントがない場合 -->
    @if (approvalEvents.length === 0) {
      <div class="no-events">
        イベントがありません。
      </div>
    }
  }
}

<!-- タブレット・SP（1023px以下）用：1件1枚のカード（起票・承認タブ共通。表は非表示） -->
<ng-template #eventCard let-event let-approval="approval">
  <div class="event-card">
    <div class="card-head">
      <!-- 帳票（黒枠）・ステータス（詳細画面と同じ灰色の帯）・承認依頼・カテゴリー -->
      <div class="card-tags">
        <span class="card-doc-type">{{ getDocumentTypeLabel(event.documentType) }}</span>
        <span class="card-status">{{ getStatusLabel(event.status) }}</span>
        <span class="event-category">{{ event.category }}</span>
      </div>
      <!-- 差戻し・承認依頼はステータスの行とイベント名の間に置く -->
      @if (!approval && event.status == 'returned') {
        <div class="card-returned"><span class="card-returned-badge">差戻し</span></div>
      }
      @if (approval && event.actionIcon === 'approval_request') {
        <div class="card-returned"><span class="card-returned-badge approval">承認依頼</span></div>
      }
      <!-- タブレット・SPでは概要は表示しない -->
      <a class="event-title" (click)="approval ? onApprovalEventClick(event) : onEventClick(event)">{{ event.title }}</a>
    </div>
    <div class="card-body">
      @if (!approval) {
        <div class="card-label">開催単位</div>
        <div class="card-value">{{ event.holdingUnit }}</div>
      }

      <div class="card-label">参加人数</div>
      <div class="card-value">
        <!-- 人数とカバー率の間は8px（空白文字は入れず、余白で空ける） -->
        @if (event.participantCount !== null) {
          <span>{{ event.participantCount }}人</span>
          @if (event.coverageRate !== null) {
            <span class="card-sub card-rate">カバー率 {{ event.coverageRate }} %</span>
          }
        } @else {
          -
        }
      </div>

      <div class="card-label">公開範囲</div>
      <div class="card-value">
        {{ event.category === '労使交渉・協議・意見交換' || event.category === '組合年間行事' ? '自組織' : '他組織' }}@if (event.publicScope.permissionRole) {・{{ event.publicScope.permissionRole }}}
      </div>

      <!-- 開催日：4日以上ある場合は3つ目の日付の右に「など」。期間は「〇〇から」「〇〇まで」の2行 -->
      <div class="card-label">開催日</div>
      <div class="card-value">
        @for (date of getCardDisplayDates(event); track $index; let last = $last) {
          <div class="event-date">{{ date }}@if (last && hasMoreDates(event)) {<span class="more-dates-inline">など</span>}</div>
        }
      </div>

      <!-- 承認進捗は最終更新日の上に置く -->
      <!-- 起票者（承認タブ）：承認進捗の上に、役職・名前・担当の順で1行ずつ -->
      @if (approval) {
        <div class="card-label">起票者</div>
        <div class="card-value card-drafter">
          @if (event.drafter.position) {
            <div>{{ event.drafter.position }}</div>
          }
          @if (event.drafter.name) {
            <div>{{ event.drafter.name }}</div>
          }
          @if (event.drafter.branch) {
            <div>{{ event.drafter.branch }}</div>
          }
          @if (getDrafterDepartmentText(event)) {
            <div>{{ getDrafterDepartmentText(event) }}</div>
          }
        </div>
      }

      <div class="card-label">承認進捗</div>
      <div class="card-value card-approval">
        @if (getFormattedDate(event.approvalProgress.submittedDate)) {
          <div class="approval-row">
            <span class="approval-label">起票</span>
            <span class="approval-status"></span>
            <span class="approval-date" [class.grayed]="event.approvalProgress.isSubmittedGrayed">{{ getFormattedDate(event.approvalProgress.submittedDate) }}</span>
          </div>
        }
        @for (step of event.approvalProgress.steps; track $index) {
          @if (step.level !== null && step.status !== null) {
            <div class="approval-row">
              <span class="approval-label">{{ step.level }}次承認</span>
              <span class="approval-status" [class]="'status-' + step.status">{{ getApprovalStatusLabel(step.status) }}</span>
              <span class="approval-date" [class.grayed]="step.status === 'reviewing'">{{ step.status === 'reviewing' ? '' : getFormattedDate(step.date) }}</span>
            </div>
          }
        }
      </div>

      <div class="card-label">最終更新日</div>
      <div class="card-value">{{ getFormattedDate(event.lastUpdatedAt) }}</div>
    </div>
  </div>
</ng-template>
